import React from 'react';

import { HeaderMobileReg } from '@interlayer/js/app/components/main/Registration/components/common/HeaderMobileReg';
import { RetailRegHeader } from '../Registration/components/common/RetailRegHeader';
import { HeaderMobile } from './components/HeaderMobile';

import { componentService } from '@core/js/services/component.service';

import { useInDesktop } from '@interlayer/js/app/hooks/device/hooks/useMediaQuery';
import { useIsLayoutRetailRegistrationWithoutHeader } from '@interlayer/js/app/hooks/menu/useIsLayoutRetailRegistrationWithoutHeader';
import { useIsLayoutWithoutHeader } from '@interlayer/js/app/hooks/menu/useIsLayoutWithoutHeader';

export const DefaultHeader: React.FC = () => {
    const isDesktop = useInDesktop();
    const isLayoutWithoutHeader = useIsLayoutWithoutHeader();
    const isLayoutRetailRegistration = useIsLayoutRetailRegistrationWithoutHeader();

    if (isLayoutWithoutHeader && !isDesktop) {
        return (
            <HeaderMobileReg />
        );
    }

    if (isLayoutRetailRegistration) {
        return (
            <RetailRegHeader />
        );
    }

    return isDesktop ? null : <HeaderMobile />;
};

componentService.registerWebContentComponents({ DefaultHeader });
